import {Injectable} from '@angular/core';
import {BaseEndpoint} from "../../base/endpoints/base.endpoint";
import {IParams} from "../../base/endpoints/iparams";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class WebAppEndpoint extends BaseEndpoint {

  constructor() {
    super();
  }

  static CATEGORIES = {
    SEARCH(params: IParams): string {
      return environment.base_url + "/api/v1/public/categories"
        + BaseEndpoint.toParamString(params)
    },
    SAVE_INTERESTS(): string {
      return environment.base_url + "/api/v1/user-interests"
    },
    FETCH_INTERESTS() {
      return environment.base_url + "/api/v1/user-interests/my-interests"
    },
    FETCH_ATTRIBUTES(params: IParams) {
      return environment.base_url + "/api/v1/public/categories/attributes"
        + BaseEndpoint.toParamString(params)
    }
  }

  static PRODUCTS = {
    SEARCH(params: IParams): string {
      return environment.base_url + '/api/v1/public/products'
        + BaseEndpoint.toParamString(params)
    },
    SEARCH_BRANDS(params: IParams): string {
      return environment.base_url + '/api/v1/public/brands'
        + BaseEndpoint.toParamString(params)
    },
    GET_TOP_PRODUCTS(params: IParams): string {
      return environment.base_url + '/api/v1/public/ratings/top-rated-products'
        + BaseEndpoint.toParamString(params)
    },
    GET_DETAILS(slug: string): string {
      return environment.base_url + '/api/v2/public/products/' + slug;
    }
  }
  static VENDORS = {
    SEARCH(params: IParams): string {
      return environment.base_url + '/api/v1/public/vendors'
        + BaseEndpoint.toParamString(params)
    }
  }


  static ATTRIBUTES = {
    GET_ATTRS_FOR_PRODUCT(productId: number, params: IParams): string {
      return environment.base_url + '/api/v1/public/products/' + productId + '/attributes'
        + BaseEndpoint.toParamString(params)
    }
  }

  static REVIEWS = {
    FETCH_RECENT_REVIEW(params: IParams): string {
      return environment.base_url + '/api/v1/public/reviews/recent-reviews'
        + BaseEndpoint.toParamString(params)
    },
    CREATE_REVIEW(params: IParams): string {
      return environment.base_url + '/api/v1/reviews'
        + BaseEndpoint.toParamString(params)
    },
    UPDATE_REVIEW(reviewId: number, params: IParams): string {
      return environment.base_url + '/api/v1/reviews/' + reviewId
        + BaseEndpoint.toParamString(params)
    },
    FETCH_MY_REVIEW(productId: number) {
      return environment.base_url + '/api/v1/products/' + productId + '/my-review'
    },
    FETCH_REVIEW(productSlug: string, reviewSlug: string) {
      return environment.base_url + '/api/v2/public/' + productSlug + '/reviews/' + reviewSlug
    },
    FETCH_PRODUCT_REVIEWS(productId: number, params: IParams) {
      return environment.base_url + '/api/v1/public/products/' + productId + '/reviews'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_USER_REVIEWS(username: string, params: IParams) {
      return environment.base_url + '/api/v1/public/users/' + username + '/reviews'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_AVG_RATINGS(productId: number): string {
      return environment.base_url + '/api/v1/public/products/' + productId + '/avg_ratings';
    },
    SEND_VERIFICATION_REQUEST(): string {
      return environment.base_url + '/api/v1/review-verifications';
    },
    GET_VERIFICATION_FOR_REVIEW(reviewId: number): string {
      return environment.base_url + '/api/v1/public/reviews/' + reviewId + '/verification';
    },
    RECONSIDER_VERIFICATION(verificationId: number): string {
      return environment.base_url + '/api/v1/review-verifications/' + verificationId + '/apply-for-reconsideration';
    }
  }

  static POSTS = {
    FETCH_COMMENTS(postId: number, params: IParams) {
      return environment.base_url + '/api/v1/social/posts/' + postId + '/comments'
        + BaseEndpoint.toParamString(params)
    },
    SUBMIT_POST() {
      return environment.base_url + '/api/v1/social/posts'
    },
    UPDATE_POST(id: number) {
      return environment.base_url + '/api/v1/social/posts/' + id
    },
    DELETE_POST(id: number) {
      return environment.base_url + '/api/v1/social/posts/' + id
    },
    REACT_TO_POST(postId: number) {
      return environment.base_url + '/api/v1/social/posts/' + postId + '/reactions';
    },
    FETCH_NEWS_FEED_POSTS(params: IParams) {
      return environment.base_url + '/api/v1/social/posts'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_POST(id: number) {
      return environment.base_url + '/api/v1/social/posts/' + id
    },
    FETCH_POST_REACTIONS(postId: number, params: IParams) {
      return environment.base_url + "/api/v1/social/posts/" + postId + "/reactions"
        + BaseEndpoint.toParamString(params)
    },
    FETCH_REACTIONS(params: IParams) {
      return environment.base_url + "/api/v1/social/reactions"
        + BaseEndpoint.toParamString(params)
    },
    FETCH_USER_POSTS(username: string, params: IParams) {
      return environment.base_url + "/api/v1/public/social/users/" + username + "/posts"
        + BaseEndpoint.toParamString(params)
    },
    FETCH_TRENDING_TAGS(params: IParams) {
      return environment.base_url + "/api/v1/public/social/posts/trending-tags"
        + BaseEndpoint.toParamString(params)
    },
    POST_REVIEW_REPORT(): string {
      return environment.base_url + '/api/v1/report-reviews';
    },
    GET_REPORT_DETAILS_FOR_POST(postId: number): string {
      return environment.base_url + '/api/v1/report-reviews/my-reports/for-post/' + postId;
    },
    GET_REPORT_COUNT_FOR_POST(postId: number): string {
      return environment.base_url + '/api/v1/report-reviews/my-reports/for-post/' + postId + '/count';
    }
  }


  static NOTIFICATIONS = {
    COUNT_UNREAD(params: IParams): string {
      return environment.base_url + '/api/v1/notifications/unread/count'
        + BaseEndpoint.toParamString(params)
    },
    MARK_READ(params: IParams): string {
      return environment.base_url + '/api/v1/notifications/mark-read'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_MY_NOTIFICATIONS(params: IParams): string {
      return environment.base_url + '/api/v1/my-notifications'
        + BaseEndpoint.toParamString(params)
    },
    DELETE(): string {
      return environment.base_url + '/api/v1/notifications/'
    }
  }


  static USER = {
    FETCH_FOLLOW_STATS(username: string) {
      return environment.base_url + '/api/v1/follows/' + username + '/stats'
    },
    FOLLOW_A_USER(username: string): string {
      return environment.base_url + '/api/v1/follows/follow/' + username
    },
    UNFOLLOW_A_USER(username: string): string {
      return environment.base_url + '/api/v1/follows/unfollow/' + username
    },
    GET_MY_FOLLOWERS() {
      return environment.base_url + '/api/v1/follows/my-followers'
    },
    GET_MY_FOLLOWING() {
      return environment.base_url + '/api/v1/follows/following'
    },
    GET_MY_PROFILE() {
      return environment.base_url + '/api/v1/my-profile'
    },
    UPDATE_MY_PROFILE() {
      return environment.base_url + '/api/v1/my-profile'
    },
    DELETE_ME() {
      return environment.base_url + '/api/v1/users/delete-me'
    },
    SEARCH(params: IParams) {
      return environment.base_url + '/api/v3/admin/users'
        + BaseEndpoint.toParamString(params)
    }
  }

  static ACTIVITY_LOGS = {
    ADMIN_SEARCH(params: IParams) {
      return environment.base_url + '/api/v1/admin/activity-logs'
        + BaseEndpoint.toParamString(params)
    }
  }
  static REQUEST_CREDENTIALS = {
    ADMIN_SEARCH_LOCKOUTS(params: IParams) {
      return environment.base_url + '/api/v1/admin/request-credentials/lockouts'
        + BaseEndpoint.toParamString(params)
    }
  }

//   admin panel urls

  static QUESTIONNAIRES = {
    SEARCH_ENDPOINT: environment.base_url + '/api/v1/questionnaires',
    SEARCH_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/questionnaires',

    SEARCH(endpoint: string, params: IParams): string {
      return endpoint + BaseEndpoint.toParamString(params)
    },
    GET_DETAILS(id: number): string {
      return environment.base_url + '/api/v1/questionnaires/' + id
    },
    DELETE(): string {
      return environment.base_url + '/api/v1/questionnaires/'
    },
    CREATE(): string {
      return environment.base_url + '/api/v1/questionnaires'
    },
    UPDATE(id: number): string {
      return environment.base_url + '/api/v1/questionnaires/' + id
    },
    TOGGLE_APPROVAL(id: number, params: IParams): string {
      return environment.base_url + '/api/v1/questionnaires/' + id + '/toggle-approval'
        + BaseEndpoint.toParamString(params)
    },
    RESULT_SHEET(id: number): string {
      return environment.base_url + '/api/v1/questionnaires/' + id + '/result-sheet'
    },
    GENERATE_QUESTION_REVISIONS_FOR_LABEL(params: IParams) {
      return environment.base_url + '/api/v2/admin/question-revisions/generate-for-label'
        + BaseEndpoint.toParamString(params)
    }
  }

  static POLLS = {
    SEARCH_ENDPOINT: environment.base_url + '/api/v1/polls',
    SEARCH_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/polls',
    SEARCH(endpoint: string, params: IParams): string {
      return endpoint + BaseEndpoint.toParamString(params)
    },
    GET_DETAILS(id: number): string {
      return environment.base_url + '/api/v1/polls/' + id
    },
    CREATE(): string {
      return environment.base_url + '/api/v1/polls'
    },
    DELETE(): string {
      return environment.base_url + '/api/v1/polls/'
    },
    UPDATE(id: number): string {
      return environment.base_url + '/api/v1/polls/' + id
    },
    IMPORT(questionnaireId: number) {
      return environment.base_url + "/api/v2/questionnaires/" + questionnaireId + "/import-questions"
    }
  }

  static VOTES = {
    SEARCH(params: IParams): string {
      return environment.base_url + '/api/v1/admin/votes'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_USER_VOTE_STATS(params: IParams): string {
      return environment.base_url + '/api/v1/admin/votes/user-vote-count-stats'
        + BaseEndpoint.toParamString(params)
    },
    FETCH_POLL_VOTE_STATS(params: IParams): string {
      return environment.base_url + '/api/v1/admin/votes/poll-vote-count-stats'
        + BaseEndpoint.toParamString(params)
    }
  }

  static POLL_STATISTICS = {
    OVERVIEW_STATS_ENDPOINT: environment.base_url + '/api/v1/poll-stats/overview',
    OVERVIEW_STATS_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/poll-stats/overview',
    DATE_WISE_POLL_COUNTS_ENDPOINT: environment.base_url + '/api/v1/poll-stats/date-wise-poll-counts',
    DATE_WISE_POLL_COUNTS_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/poll-stats/date-wise-poll-counts',

    OVERVIEW_STATS(endpoint: string, params: IParams): string {
      return endpoint + BaseEndpoint.toParamString(params)
    },

    DATE_WISE_POLL_COUNTS(endpoint: string, params: IParams): string {
      return endpoint + BaseEndpoint.toParamString(params)
    }
  }

  static POLL_OPTIONS = {
    SEARCH(params: IParams): string {
      return environment.base_url + '/api/v1/poll-options'
        + BaseEndpoint.toParamString(params)
    },
    CREATE(): string {
      return environment.base_url + '/api/v1/poll-options'
    },
    DELETE(): string {
      return environment.base_url + '/api/v1/poll-options/'
    },
    UPDATE(id: number): string {
      return environment.base_url + '/api/v1/poll-options/' + id
    }
  }
  static LABELS = {
    SEARCH_ENDPOINT: environment.base_url + '/api/v1/labels',
    SEARCH_ENDPOINT_FOR_POLLBOX: environment.base_url + '/api/v1/public/labels/POLLBOX/children',
    SEARCH_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/labels',
    SEARCH(endpoint: string, params: IParams): string {
      return endpoint + BaseEndpoint.toParamString(params)
    },
    CREATE(): string {
      return environment.base_url + '/api/v1/labels'
    },
    UPDATE(id: number): string {
      return environment.base_url + '/api/v1/labels/' + id
    }
  }
}
